import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import {
  calculTotal,
  formadate,
  formatDateAndTime,
} from "../../_App/Helpers/helpers";
import InventaireForm from "./InventaireForm";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { useAppSelector } from "../../_App/Redux/hooks";

export default function InventaireDetaliTable({
  t,
  ShowModal,
  setShowModal,
  inventaire,
  listInventairedetails,
  listdOrganisations,
  mvt,
}: any) {
  const [showModalFormInventaire, setshowModalFormInventaire] = useState(false);
  const updateinventaire = () => {
    setShowModal(false);
    setshowModalFormInventaire(true);
  };

  
  
  const calculEcart = listInventairedetails[inventaire?._id]
    ? listInventairedetails[inventaire?._id].reduce(
        (sum: any, item: any) => sum + ((item?.quantite  -item?.stk_before_inventaire  )|| 0),
        0
      )
    : 0;
  const parametrage_caisse = useAppSelector(parametrageCaisse);
  return (
    <div>
      <Modal
        show={ShowModal}
        onHide={() => setShowModal(false)}
        className="modal-2"
        dialogClassName="modal-90w"
        backdropClassName="modal-backdrop-2"
      >
        <Modal.Header closeButton>
          <Modal.Title className="c-primary">
            {" "}
            <span>{t("Inventaire details")}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row mb-2">
            <div className="col-3">
              <strong>{t("Code inventaire")}</strong>{" "}
              <span>{inventaire?.code_inventaire}</span>
            </div>
            <div className="col-3">
              <strong>{t("Titre")} </strong> <span>{inventaire?.titre}</span>
            </div>
            <div className="col-3">
              <strong>{t("Organisation")}</strong>{" "}
              <span>
                {listdOrganisations?.find(
                  (element: any) => element._id === inventaire?.organisation_id
                )?.nom || inventaire?.organisation_id?.nom}
              </span>
            </div>
            <div className="col-3">
              <strong>{t("Depots")} </strong>{" "}
              <span>{inventaire?.depots_id.libelle}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-3">
              <strong>{t("user")} </strong>{" "}
              <span>
                {inventaire?.user.nom}
                {""}
                {inventaire?.user?.prenom}
              </span>
            </div>
            <div className="col-3">
              <strong>{t("Date creation")} </strong>{" "}
              <span>{formatDateAndTime(inventaire?.createdAt)}</span>
            </div>
            <div className="col-3">
              <strong>{t("Date modification")} </strong>{" "}
              <span>{formatDateAndTime(inventaire?.updatedAt)}</span>
            </div>
          </div>
          
          <div className="row mb-2">
            {inventaire?.listmarques?.length > 0 && (
              <div className="col-3">
                <strong>{t("Marque")} :</strong>{" "}
                {inventaire.listmarques.map((m: any, index: any) => (
                  <span key={m?._id || index}>{m?.libelle?.fr} </span>
                ))}
              </div>
            )}

            {inventaire?.listfamilles?.length > 0 && (
              <div className="col-3">
                <strong>{t("Famille")} :</strong>{" "}
                {inventaire.listfamilles.map((m: any, index: any) => (
                  <span key={m?._id || index}>{m?.libelle?.fr} </span>
                ))}
              </div>
            )}
             {inventaire?.ref1 && inventaire?.ref1!=='' && (
              <div className="col-3">
                <strong>{t("Ref1")} :</strong>{" "}
                {inventaire.ref1}
              </div>
            )}
             {inventaire?.ref1 && inventaire?.ref2!=='' && (
              <div className="col-3">
                <strong>{t("Ref2")} :</strong>{" "}
                {inventaire.ref2}
              </div>
            )}
          </div>
          <div className="row">
            <table className="table table-bordered mb-5">
              <thead>
                <tr>
                  <th>{t("Article")}</th>
                  <th>{t("code Article")}</th>
                  <th>{t("Prix Vente TTC")}</th>
                  <th>
                    {t("Qunatite")}{" "}
                    {calculTotal(
                      listInventairedetails[inventaire?._id],
                      "quantite"
                    )}
                  </th>
                  {parametrage_caisse?.ecart_inventaire && (
                    <>
                      <th>
                        {t("Qunatite calculer ")}{" "}
                        {calculTotal(
                          listInventairedetails[inventaire?._id],
                          "stk_before_inventaire"
                        )}
                      </th>
                      <th>{t("Ecart ")}{' '}{calculEcart}</th>
                    </>
                  )}
                </tr>
              </thead>

              {listInventairedetails[inventaire?._id] &&
              listInventairedetails[inventaire?._id].length !== 0 ? (
                <tbody>
                  {listInventairedetails[inventaire._id]?.map(
                    (item: any, index: number) => (
                      <tr key={index}>
                        <td>{index} -{item.article?.titre.fr}</td>
                        <td>{item.article?.code_article}</td>
                        <td>{item.prix_vente_ttc?.toFixed(3)}</td>
                        <td>{item.quantite}</td>
                        {parametrage_caisse?.ecart_inventaire && (
                          <>
                            <td>{item?.stk_before_inventaire}</td>
                            <td>
                              {item?.quantite - item?. stk_before_inventaire}
                            </td>
                          </>
                        )}
                      </tr>
                    )
                  )}
                </tbody>
              ) : (
                <tr>{t("aucun detail")}</tr>
              )}

              <tbody></tbody>
            </table>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {mvt === undefined && !inventaire?.confirmer ? (
            <button onClick={updateinventaire} className="btn btn-primary-app">
              {t("Modifier")}
            </button>
          ) : null}
        </Modal.Footer>
      </Modal>

      <InventaireForm
        Inventaire={inventaire}
        list_details_inventaire={listInventairedetails[inventaire?._id]}
        ShowModal={showModalFormInventaire}
        setShowModal={setshowModalFormInventaire}
      />
    </div>
  );
}
